'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleParallax = exports.isMobileDevice = exports.getSizedImage = exports.consumeSessionStorage = exports.getSessionStorage = exports.setSessionStorage = exports.formatMoney = exports.bindUIActions = exports.interceptEndUserCartApiCalls = exports.isJSON = exports.getResourceJson = exports.handlize = exports.isSafari = exports.htmlDecode = exports.getAlternativeTemplate = exports.getUrlParameterByName = exports.debounce = exports.checkEmail = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  copy: '[data-copy]'
};

/**
 * Email Validation
 *
 * Returns true or false based on the email address passed into it
 */
var checkEmail = exports.checkEmail = function checkEmail(emailAddress) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(emailAddress);
};

/**
 * Debounce
 *
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * Usage:
 * var lazyLayout = export const debounce(calculateLayout, 300);
 * $(window).resize(lazyLayout);
 */

var debounce = exports.debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var self = this;
    var args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(self, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(self, args);
  };
};

/**
 * Get URL Parameter By Name
 *
 * Returns value of the named url parameter
 */
var getUrlParameterByName = exports.getUrlParameterByName = function getUrlParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return false;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

var getAlternativeTemplate = exports.getAlternativeTemplate = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resource, templateName) {
    var json = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var url, options;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/' + resource + '?view=' + templateName;
            options = { credentials: 'include' };

            if (!json) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return fetch(url, options).then(function (res) {
              return res.json();
            });

          case 5:
            return _context.abrupt('return', _context.sent);

          case 8:
            _context.next = 10;
            return fetch(url, options).then(function (res) {
              return res.text();
            });

          case 10:
            return _context.abrupt('return', _context.sent);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getAlternativeTemplate(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var htmlDecode = exports.htmlDecode = function htmlDecode(input) {
  var e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};

var isSafari = exports.isSafari = function isSafari() {
  return (/constructor/i.test(window.HTMLElement) || function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification)
  );
};

// accepts string, returns string
// Source: https://gist.github.com/tyteen4a03/3420a9e121d13b091343
var handlize = exports.handlize = function handlize(str) {
  str = str.toLowerCase();
  var toReplace = ['"', "'", '\\', '(', ')', '[', ']', '$'];
  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '');
  }
  str = str.replace(/\W+/g, '-');
  if (str.charAt(str.length - 1) == '-') {
    str = str.replace(/-+\z/, '');
  }
  if (str.charAt(0) == '-') {
    str = str.replace(/\A-+/, '');
  }
  return str;
};

var getResourceJson = exports.getResourceJson = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(resource, handle) {
    var retrievedResources, cachedResource, url, options;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            retrievedResources = window.bva.retrievedData[resource] || {};
            cachedResource = retrievedResources[handle];

            if (cachedResource) {
              _context2.next = 10;
              break;
            }

            url = '/' + resource + '/' + handle + '.json';
            options = { credentials: 'include' };
            _context2.next = 7;
            return fetch(url, options).then(function (res) {
              return res.json();
            }).then(function (_ref3) {
              var product = _ref3.product;

              window.bva.retrievedData[resource] = Object.assign({}, retrievedResources, (0, _defineProperty3.default)({}, handle, product));
              return product;
            });

          case 7:
            return _context2.abrupt('return', _context2.sent);

          case 10:
            return _context2.abrupt('return', cachedResource);

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getResourceJson(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var isJSON = exports.isJSON = function isJSON(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

var interceptEndUserCartApiCalls = exports.interceptEndUserCartApiCalls = function interceptEndUserCartApiCalls() {
  return function (open) {
    XMLHttpRequest.prototype.open = function (method, url, async, user, pass) {
      var _this = this;

      if (url.includes('/cart/update.js') && method == 'POST') {
        this.addEventListener('readystatechange', function () {
          if (isJSON(_this.response)) {
            var cart = JSON.parse(_this.response);
            var _cart$token = cart.token,
                token = _cart$token === undefined ? false : _cart$token,
                _cart$auth = cart.auth,
                auth = _cart$auth === undefined ? false : _cart$auth;

            if (token && !auth) {
              console.log('[WARN] Unauthorized ajax api call');
              var detail = Object.assign({ auth: true }, cart);
              var event = new CustomEvent('cart.updated', { detail: detail });
              document.dispatchEvent(event);
            }
          }
        }, false);
      }
      open.apply(this, arguments);
    };
  }(XMLHttpRequest.prototype.open);
};

var copyToClipboard = function copyToClipboard(event) {
  var _navigator = navigator,
      _navigator$clipboard = _navigator.clipboard,
      clipboard = _navigator$clipboard === undefined ? false : _navigator$clipboard;

  if (clipboard) {
    var text = $(event.currentTarget).text();
    navigator.clipboard.writeText(text).then(function () {
      return alert('Copied to clipboard!');
    });
  }
};

var bindUIActions = exports.bindUIActions = function bindUIActions() {
  $(dom.copy).on('click', function () {
    return document.execCommand('copy');
  });
  $(dom.copy).on('copy', copyToClipboard);
};

var defaultOption = function defaultOption(opt, def) {
  return typeof opt == 'undefined' ? def : opt;
};

var formatWithDelimiters = function formatWithDelimiters(number, precision, thousands, decimal) {
  precision = defaultOption(precision, 2);
  thousands = defaultOption(thousands, ',');
  decimal = defaultOption(decimal, '.');

  if (isNaN(number) || number == null) {
    return 0;
  }

  number = (number / 100.0).toFixed(precision);

  var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

  return dollars + cents;
};

var formatMoney = exports.formatMoney = function formatMoney() {
  var cents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var format = arguments[1];

  if (!cents && cents !== 0) return;
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.bva.moneyFormat;

  var centsArray = cents.toString().split('');
  var hasTrailingZeros = centsArray[centsArray.length - 1] == '0' && centsArray[centsArray.length - 2] == '0';
  var precision = hasTrailingZeros ? 0 : 2;

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, precision);
      break;
    case 'amount_with_decimals':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, precision);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

window.bva = window.bva || {};
window.bva.formatMoney = formatMoney;

// set item in session storage
var setSessionStorage = exports.setSessionStorage = function setSessionStorage(name, value) {
  sessionStorage.setItem(name, value);
};
// returns a session storage item
var getSessionStorage = exports.getSessionStorage = function getSessionStorage(name) {
  var storedItem = sessionStorage.getItem(name);
  return storedItem ? storedItem : false;
};
// will return a session item, and delete it as well
var consumeSessionStorage = exports.consumeSessionStorage = function consumeSessionStorage(name) {
  var storedItem = sessionStorage.getItem(name);
  sessionStorage.removeItem(name);
  return storedItem ? storedItem : false;
};

var getSizedImage = exports.getSizedImage = function getSizedImage(url, size) {
  var pixelDensityRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var extDotIndex = url.lastIndexOf('.');
  var urlArray = url.split('');
  var ext = urlArray.splice(extDotIndex).join('');
  var path = urlArray.join('');
  var pixelRatio = pixelDensityRatio ? '@' + pixelDensityRatio + 'x' : '';
  return path + '_' + size + ext + pixelRatio;
};

var isMobileDevice = exports.isMobileDevice = function isMobileDevice() {
  return window.innerWidth <= 991;
};

// vanilla js
var simpleParallax = exports.simpleParallax = function simpleParallax(element, parent) {
  var parentOffsetTop = parent.getBoundingClientRect().top;
  var parentOffsetBottom = parent.getBoundingClientRect().bottom;
  if (parentOffsetTop < 0 && parentOffsetBottom > -0) {
    var depth = parentOffsetTop / parent.getBoundingClientRect().height * -1;
    var adjust = window.innerWidth >= 768 ? depth * 45 : depth * 75;
    element.style.transform = 'translateY(' + adjust + '%)';
  } else {
    element.style.transform = 'translateY(0)';
  }
};